/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styled from 'styled-components';
import { useCollections } from '@members/copy/copy.generated';
import { Collections } from '@members/copy/models.generated/Collections';
import { SkipLinks } from '@members/copy/models.generated/SkipLinks';
import { LayoutWithoutUserNav } from '@members/layout/containers';

const COLLECTIONS_CONTENT_ID = 'collections-content';

export const CollectionsPageLayout: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  return (
    <LayoutWithoutUserNav
      titleSegments={[useCollections(Collections.Collections)]}
      skipLinks={{
        first: {
          skipLinkId: SkipLinks.SkipToContent,
          contentElementId: COLLECTIONS_CONTENT_ID,
        },
      }}
    >
      <Main id={COLLECTIONS_CONTENT_ID}>{children}</Main>
    </LayoutWithoutUserNav>
  );
};

const Main = styled.main`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
`;
